import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  createTrainingCertificateRoute,
  getAllTrainingCertificatesRoute,
  updateTrainingCertificateRoute,
  deleteTrainingCertificateRoute,
  searchTrainingCertificateRoute,
} from '../../utils/apiRoutes';

export const createTrainingCertificateAsync = createAsyncThunk(
  `${moduleName}/createTrainingCertificateAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios({
        method: 'POST',
        url: createTrainingCertificateRoute(),
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data) || { message: error.message }
      );
    }
  }
);

export const getAllTrainingCertificatesAsync = createAsyncThunk(
  `${moduleName}/getAllTrainingCertificatesAsync`,
  async (payload) => {
    const { params } = payload || {};
    const response = await axios({
      method: 'GET',
      url: getAllTrainingCertificatesRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const updateTrainingCertificateAsync = createAsyncThunk(
  `${moduleName}/updateTrainingCertificateAsync`,
  async ({ id, payload }) => {
    const response = await axios({
      method: 'PUT',
      url: updateTrainingCertificateRoute(id),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const deleteTrainingCertificateAsync = createAsyncThunk(
  `${moduleName}/deleteTrainingCertificateAsync`,
  async (id) => {
    const response = await axios({
      method: 'DELETE',
      url: deleteTrainingCertificateRoute(id),
    });
    const data = response.data;
    return data;
  }
);

export const searchTrainingCertificateAsync = createAsyncThunk(
  `${moduleName}/searchTrainingCertificateAsync`,
  async (payload) => {
    const response = await axios({
      method: 'POST',
      url: searchTrainingCertificateRoute(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

const TrainingCertificateSlice = createSlice({
  name: `${moduleName}/TrainingCertificate`,
  initialState: {
    loading: false,
    certificates: [],
    searchResults: [],
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    searchLoading: false,
    error: null,
  },
  reducers: {
    clearSearchResults: (state) => {
      state.searchResults = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: {
    // Create
    [createTrainingCertificateAsync.pending]: (state) => {
      state.createLoading = true;
      state.error = null;
    },
    [createTrainingCertificateAsync.fulfilled]: (state, action) => {
      state.createLoading = false;
      state.certificates.data.unshift(action.payload);
    },
    [createTrainingCertificateAsync.rejected]: (state, action) => {
      state.createLoading = false;
      state.error = action.error.message;
    },

    // Get all
    [getAllTrainingCertificatesAsync.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getAllTrainingCertificatesAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.certificates = action.payload;
    },
    [getAllTrainingCertificatesAsync.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    // Update
    [updateTrainingCertificateAsync.pending]: (state) => {
      state.updateLoading = true;
      state.error = null;
    },
    [updateTrainingCertificateAsync.fulfilled]: (state, action) => {
      state.updateLoading = false;
      const idx = state.certificates.data.findIndex(
        (c) => c._id === action.payload._id
      );
      if (idx !== -1) state.certificates.data[idx] = action.payload;
    },
    [updateTrainingCertificateAsync.rejected]: (state, action) => {
      state.updateLoading = false;
      state.error = action.error.message;
    },

    // Delete
    [deleteTrainingCertificateAsync.pending]: (state) => {
      state.deleteLoading = true;
      state.error = null;
    },
    [deleteTrainingCertificateAsync.fulfilled]: (state, action) => {
      state.deleteLoading = false;
      state.certificates = state.certificates.data.filter(
        (c) => c._id !== action.payload._id
      );
    },
    [deleteTrainingCertificateAsync.rejected]: (state, action) => {
      state.deleteLoading = false;
      state.error = action.error.message;
    },

    // Search
    [searchTrainingCertificateAsync.pending]: (state) => {
      state.searchLoading = true;
      state.error = null;
    },
    [searchTrainingCertificateAsync.fulfilled]: (state, action) => {
      state.searchLoading = false;
      state.searchResults = action.payload;
    },
    [searchTrainingCertificateAsync.rejected]: (state, action) => {
      state.searchLoading = false;
      state.error = action.error.message;
    },
  },
});

export const { clearSearchResults, clearError } =
  TrainingCertificateSlice.actions;
export default TrainingCertificateSlice.reducer;
